import React from "react";

import { LineupContentFeatureLede } from "~components/modules";
import {
    type MagazineIssue,
    itemHasMagazineCoverImage,
    ZoneType,
    ZoneColumnCombo,
    ModuleSource,
} from "~types/types";

import { getFeaturesMagazineModules } from "./utils";

export interface MagazineLedeProps {
    magazineIssues: MagazineIssue;
    pageId: string;
    isLastInColumn?: boolean;
}

export default function MagazineLede({
    magazineIssues,
    pageId,
    isLastInColumn,
}: MagazineLedeProps) {
    const featuresModule = getFeaturesMagazineModules(magazineIssues);

    if (featuresModule.length < 1) {
        return null;
    }

    const featuresModuleItemsWithCoverImages = featuresModule[0].items.filter(
        (item) => itemHasMagazineCoverImage(item)
    );

    if (featuresModuleItemsWithCoverImages.length < 1) {
        return null;
    }

    return (
        <section data-zonekind={ZoneType.Full} data-component="zone">
            <section data-column={1}>
                <LineupContentFeatureLede
                    componentName="LineupContentFeatureLede"
                    id="lineup-content-feature-lede-magazine"
                    items={featuresModuleItemsWithCoverImages}
                    pageId={pageId}
                    useCoverImage
                    modules={[]}
                    renderingLocation={ZoneColumnCombo.fullWidthContentWell}
                    source={ModuleSource.Canonical}
                    type="lineup_content"
                    variation="feature_lede"
                    zoneName="magazine_irrelevant_zone_name"
                    theme={featuresModuleItemsWithCoverImages[0]?.brand}
                    isLastInColumn={isLastInColumn}
                />
            </section>
        </section>
    );
}
